import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.CUSTOMER_SET_CUSTOMER_INFO_LIST]: (state, payload) => {
    state.customers = payload.customerList

    // const base = payload.customerList

    // const customerListTmp = base.map((ele) => {
    //   const recipientTmp = ele.recipients.map((subEle) => {
    //     return {
    //       recipientId: subEle.recipientId,
    //       customerId: subEle.customerId,
    //       name: subEle.name,
    //       addressCountryId: subEle.addressCountryId,
    //       postalCode: subEle.postalCode,
    //       regionId: subEle.regionId,
    //       address1: subEle.address1,
    //       address2: subEle.address2,
    //       phoneNumberCountryId: subEle.phoneNumberCountryId,
    //       phoneNumber: subEle.phoneNumber,
    //       note: subEle.note,
    //       sortNumber: subEle.sortNumber,
    //       organizationId: subEle.organizationId,
    //       createdAt: subEle.createdAt,
    //       updatedAt: subEle.updatedAt
    //     }
    //   })

    //   return {
    //     customerId: ele.customerId,
    //     locationId: ele.locationId,
    //     customerNumber: ele.customerNumber,
    //     organizationName: ele.organizationName,
    //     sectionName: ele.sectionName,
    //     rep: ele.rep,
    //     alphabet: ele.alphabet,
    //     phoneNumberCountryId: ele.phoneNumberCountryId,
    //     phoneNumber: ele.phoneNumber,
    //     mailAddress: ele.mailAddress,
    //     wechatId: ele.wechatId,
    //     shopName: ele.shopName,
    //     url: ele.url,
    //     billingOrganizationName: ele.billingOrganizationName,
    //     billingSectionName: ele.billingSectionName,
    //     billingName: ele.billingName,
    //     billingAddressCountryId: ele.billingAddressCountryId,
    //     billingPostalCode: ele.billingPostalCode,
    //     billingRegionId: ele.billingRegionId,
    //     billingAddress1: ele.billingAddress1,
    //     billingAddress2: ele.billingAddress2,
    //     billingPhoneNumberCountryId: ele.billingPhoneNumberCountryId,
    //     billingPhoneNumber: ele.billingPhoneNumber,
    //     paymentCriteria: ele.paymentCriteria,
    //     customerCategoryId: ele.customerCategoryId,
    //     customerNote: ele.customerNote,
    //     organizationId: ele.organizationId,
    //     createdAt: ele.createdAt,
    //     updatedAt: ele.updatedAt,
    //     recipient: recipientTmp
    //   }
    // })

    // state.customers = customerListTmp
  },
  [mutationsTypes.CUSTOMER_SET_CUSTOMER_ID_NAME_LIST]: (state, payload) => {
    state.customerIdNameList = payload
  }
}

export default Mutations
